import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { foldersKeys, RequestTypes } from '@core/react-query/features/folders'
import { IFolder } from '@core/entities/folders/Folder'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateFolder = (
  options?: UseMutationOptions<
    IFolder,
    RequestErrorType,
    RequestTypes['createFolder']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...foldersKeys.createFolder,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
